import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DatePicker from "react-datepicker";
import classNames from "classnames";
import CurrencyInput from "react-currency-input";
import moment from "moment";
import { Scrollbars } from "react-custom-scrollbars";
import { withRouter } from "react-router";

import api from "../../../services/api";
import { Creators as AtendimentoActions } from "../../../store/ducks/atendimento";
import { formatMoney } from "../../../helpers";

import { Menu, Passos } from "./styles";

import "react-datepicker/dist/react-datepicker.css";

const tenant = localStorage.getItem("@ecorban-app:tenant");

class AtendimentoForm extends Component {
  state = {
    lojas: [],
    formas: [],
    categorias: [],
    status: [],
    loja: "",
    forma: "",
    categoria: "",
    subCategoria: "",
    proximo: "",
    valor: "",
    origem: "",
    observacoes: "",
    activePasso: 1,
    totalPassos: [1, 1, 1, 1, 1, 1, 1]
  };

  componentDidMount() {
    this.getLojas();
    this.getFormas();
    this.getCategorias();
    this.getOrigens();
  }

  getLojas = () => {
    api
      .get(`/stores/select`)
      .then(data => {
        const { data: lojas } = data;
        this.setState({
          lojas: lojas
        });
        if (lojas.length === 1) {
          this.setState({
            loja: lojas[0].id,
            activePasso: 2
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  getFormas = () => {
    api
      .get(`/types-of-call/select`)
      .then(data => {
        const { data: formas } = data;
        this.setState({
          formas: formas
        });
        if (formas.length === 1) {
          this.setState({
            forma: formas[0].id,
            activePasso: 3
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  getCategorias = () => {
    api
      .get(`/categories-of-call/select`)
      .then(data => {
        const { data: categorias } = data;
        this.setState({
          categorias: categorias
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getOrigens = () => {
    api
      .get(`/origins/select`)
      .then(data => {
        const { data: origens } = data;
        this.setState({
          origens: origens
        });
        if (origens.length === 1) {
          this.setState({
            origem: origens[0].id
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleTrocaPasso = passoAtual => {
    this.setState({
      activePasso: passoAtual
    });
  };

  changeCategory = id => {
    this.setState({
      categoria: id
    });

    api
      .get(`/categories-of-call/${id}/status`)
      .then(data => {
        const { data: status } = data;
        this.setState({
          status: status
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleFinaliza = () => {
    this.props.finalizaAtendimento({
      id: this.props.atendimento.atendimento.id,
      value: formatMoney(this.state.valor),
      notes: this.state.observacoes
        ? this.state.observacoes.toUpperCase().replace(/\r?\n/g, "<br />")
        : "",
      customer_id: this.props.atendimento.atendimento.customer.id,
      type_id: this.state.forma,
      category_id: this.state.categoria,
      status_id: this.state.subCategoria,
      origin_id: this.state.origem,
      store_id: this.state.loja,
      next_call: this.state.proximo
        ? this.state.proximo.format("DD/MM/YYYY HH:mm:ss")
        : "",
      finished_at: moment().format("DD/MM/YYYY HH:mm:ss")
    });
    this.props.history.push(`/${tenant}/central-de-atendimento`);
  };

  render() {
    const { totalPassos, activePasso, lojas, formas, origens } = this.state;
    return (
      <div className="display-flex flex-column" id="body-atendimento">
        <Menu>
          {totalPassos.map((passo, index) => (
            <li
              className={classNames({
                active: passo + index === activePasso,
                completed: passo + index < activePasso
              })}
              key={index}
              onClick={() =>
                passo + index < activePasso &&
                this.handleTrocaPasso(passo + index)
              }
            >
              {passo + index < activePasso ? (
                <i className="fa fa-check-circle" />
              ) : (
                passo + index
              )}
            </li>
          ))}
        </Menu>
        <Passos>
          {activePasso === 1 && (
            <fieldset>
              <legend>O atendimento foi feito em qual loja?</legend>
              <Scrollbars style={{ height: "60vh" }}>
                <div className="labels-click">
                  {lojas.map(loja => (
                    <Fragment key={`cat-${loja.id}`}>
                      <input
                        type="radio"
                        value={loja.id}
                        checked={this.state.loja === loja.id}
                        id={`input_loja_${loja.id}`}
                        name="store_id "
                        onClick={() => {
                          this.setState({
                            loja: loja.id,
                            activePasso: 2
                          });
                        }}
                      />
                      <label htmlFor={`input_loja_${loja.id}`}>
                        {loja.name}
                      </label>
                    </Fragment>
                  ))}
                </div>
              </Scrollbars>
            </fieldset>
          )}
          {activePasso === 2 && (
            <fieldset>
              <legend>Qual foi a forma de atendimento?</legend>
              <div className="labels-click">
                <Scrollbars style={{ height: "60vh" }}>
                  {formas.map(forma => (
                    <Fragment key={`cat-${forma.id}`}>
                      <input
                        type="radio"
                        value={forma.id}
                        checked={this.state.forma === forma.id}
                        id={`input_forma_${forma.id}`}
                        name="forma_id "
                        onClick={() => {
                          this.setState({
                            forma: forma.id,
                            activePasso: 3
                          });
                        }}
                      />
                      <label htmlFor={`input_forma_${forma.id}`}>
                        {forma.name}
                      </label>
                    </Fragment>
                  ))}
                </Scrollbars>
              </div>
            </fieldset>
          )}
          {activePasso === 3 && (
            <fieldset>
              <legend>Qual foi o retorno do cliente?</legend>
              <div className="labels-click">
                <Scrollbars style={{ height: "60vh" }}>
                  {this.state.categorias.map(categoria => (
                    <Fragment key={`cat-${categoria.id}`}>
                      <input
                        type="radio"
                        value={categoria.id}
                        id={`input_category_${categoria.id}`}
                        checked={this.state.categoria === categoria.id}
                        name="category_id"
                        onClick={() => {
                          this.changeCategory(categoria.id);
                        }}
                      />
                      <label htmlFor={`input_category_${categoria.id}`}>
                        {categoria.name}
                      </label>
                    </Fragment>
                  ))}
                  {this.state.categoria !== "" && (
                    <p className="mt1">
                      Selecione o motivo/ação do retorno do cliente
                    </p>
                  )}

                  {this.state.status.map(status => (
                    <Fragment key={`s-${status.id}`}>
                      <input
                        type="radio"
                        value={status.id}
                        id={`input_status_${status.id}`}
                        checked={this.state.subCategoria === status.id}
                        name="status_id"
                        onClick={() => {
                          this.setState({
                            subCategoria: status.id,
                            activePasso: 4
                          });
                        }}
                      />
                      <label htmlFor={`input_status_${status.id}`}>
                        {status.name}
                      </label>
                    </Fragment>
                  ))}
                </Scrollbars>
              </div>
            </fieldset>
          )}
          {activePasso === 4 && (
            <fieldset style={{ height: "60vh" }}>
              <legend>Foi negociado algum valor com o cliente?</legend>
              <CurrencyInput
                value={this.state.valor}
                decimalSeparator=","
                thousandSeparator="."
                prefix="R$ "
                onChangeEvent={e => {
                  this.setState({
                    valor: e.target.value
                  });
                }}
              />
              <div className="labels-click mt1">
                <Fragment>
                  <input
                    type="radio"
                    id={`pular_valor`}
                    name="pular_valor"
                    onClick={() => {
                      this.setState({
                        activePasso: 5
                      });
                    }}
                  />
                  <label htmlFor={`pular_valor`}> Próximo passo</label>
                </Fragment>
              </div>
            </fieldset>
          )}
          {activePasso === 5 && (
            <fieldset style={{ height: "60vh" }}>
              <legend>Agendar um próximo atendimento?</legend>
              <DatePicker
                selected={this.state.proximo}
                onChange={date => {
                  this.setState({
                    proximo: date
                  });
                }}
                placeholderText="Clique aqui para agendar"
                showTimeSelect
                dateFormat="DD/MM/YYYY HH:mm"
                timeFormat="HH:mm"
                timeIntervals={15}
                withPortal
                fixedHeight
                timeCaption="hr"
              />
              <div className="labels-click mt1">
                <Fragment>
                  <input
                    type="radio"
                    id={`pular_agendamento`}
                    name="pular_agendamento"
                    onClick={() => {
                      this.setState({
                        activePasso: 6
                      });
                    }}
                  />
                  <label htmlFor={`pular_agendamento`}> Próximo passo</label>
                </Fragment>
              </div>
            </fieldset>
          )}
          {activePasso === 6 && (
            <fieldset>
              <legend>Qual a origem do contato?</legend>
              <div className="labels-click">
                <Scrollbars style={{ height: "60vh" }}>
                  {origens.map(origem => (
                    <Fragment key={`cat-${origem.id}`}>
                      <input
                        type="radio"
                        value={origem.id}
                        checked={this.state.origem === origem.id}
                        id={`input_origem_${origem.id}`}
                        name="origem_id "
                        onClick={() => {
                          this.setState({
                            origem: origem.id,
                            activePasso: 7
                          });
                        }}
                      />
                      <label htmlFor={`input_origem_${origem.id}`}>
                        {origem.description}
                      </label>
                    </Fragment>
                  ))}
                </Scrollbars>
              </div>
            </fieldset>
          )}
          {activePasso === 7 && (
            <fieldset style={{ height: "60vh" }}>
              <legend>Observações do atendimento</legend>
              <textarea
                rows="5"
                placeholder="Inserir observações"
                onChange={e => this.setState({ observacoes: e.target.value })}
              />
              <div className="labels-click mt1">
                <Fragment>
                  <input
                    type="radio"
                    id={`finalizar_atendimento`}
                    name="finalizar_atendimento"
                    onClick={this.handleFinaliza}
                  />
                  <label className="finish" htmlFor={`finalizar_atendimento`}>
                    Finalizar Atendimento
                  </label>
                </Fragment>
              </div>
            </fieldset>
          )}
        </Passos>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  atendimento: state.atendimento,
  loading: state.loading.loading
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...AtendimentoActions }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AtendimentoForm)
);



// WEBPACK FOOTER //
// ./src/components/Forms/Atendimento/index.js